import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams } from '@angular/http';

import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';

export interface GeneralLayer {
	id: number;
	name: string;
	type: FeatureType;
	isArnold: boolean;
	isValid: boolean;
}
export interface LayerColumn {
	layerId: number;
	columnId: number;
	name: string;
	displayedName: string;
	type: string;
	octName: string; // ?
}

export type FeatureType = 'EL' | 'EP' | 'ELI' | 'EPI' | 'ELP' | 'EPP';

@Injectable()
export class LayersService {

	constructor(
		private requestService: CommonRequestService
	) { }
	getLayersByProject(projId: number): Promise<GeneralLayer[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/layerList';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('projectId', projId.toString());
			this.requestService.setParamsPaging(params, {
				pageNumber: 0
			});
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				if (!rsp.data) {
					resolve([]);
				} else {
					const layers: GeneralLayer[] = [];
					rsp.data.forEach((d) => {
						layers.push({
							id: d.ole_id,
							name: d.ole_name,
							type: d.olt_cd,
							isArnold: d.ole_arnold,
							isValid: d.is_valid
						});
					});
					resolve(layers);
				}
			}, (err) => {
				reject(err);
			});
		});
	}

	getLayerColumns(layerId: number, type?: 'attr' | 'lrs'): Promise<LayerColumn[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/layerColumns';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('layerId', layerId.toString());
			if (type) {
				params.set('type', type);
			}
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				if (rsp.data) {
					const cols: LayerColumn[] = [];
					rsp.data.forEach((d) => {
						const splits = d.olc_name.split('.');
						cols.push({
							name: d.olc_name,
							type: d.olc_type,
							columnId: d.olc_id,
							layerId: d.ole_id,
							octName: d.oct_name,
							displayedName: splits[splits.length - 1]
						});
					});
					resolve(cols);
				}
			}, (err) => {
				reject(err);
			});
		});
	}

	getLayers(customerId: number) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layers';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('customerId', customerId.toString());
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				if (rsp.data) {
					const layers: any[] = [];
					rsp.data.forEach((l) => {
						layers.push({
							name: l.gly_name,
							maint: l.gly_maint_type,
							state: l.lol_state,
							rowCount: l.gly_rowcount,
							loadTime: l.gly_load_time
						});
					});
					resolve(layers);
				}
			}, (err) => {
				reject(err);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/layers.service.ts